import { dialog as initialState } from 'flux/initialState';
import { dialog as actions } from 'flux/actions';

export default function (state = initialState, action) {
  const { types } = actions;
  switch (action.type) {
    case types.OPEN_DIALOG: {
      return { ...state, open: true };
    }
    case types.CLOSE_DIALOG: {
      return { ...state, open: false };
    }
    case types.INIT_DIALOG: {
      const { title, content } = action.payload;
      return { ...state, title, content };
    }
    case types.SET_CONTENT: {
      const { content } = action;
      return { ...state, content };
    }
    default:
      return state;
  }
}
